<template>
  <section id="faq" class="faq-block">
    <h2 class="h2">Frequently Asked Questions</h2>

    <div class="faq-wrapper">
      <vs-accordion :is-box="true" is-compact class="faq-list">
        <vs-accordion-item
          v-for="(item, index) in faqList"
          class="faq-list__item"
          :key="index"
        >
          <template #accordion-icon>
            <div class="faq-icon" />
          </template>
          <template #accordion-trigger>
            <h3 class="h3">{{ item.q }}</h3>
          </template>

          <div class="faq-answer">
            {{ item.a }}
          </div>
        </vs-accordion-item>
      </vs-accordion>
    </div>
  </section>
</template>

<script>
import { VsAccordion, VsAccordionItem } from '@vuesimple/vs-accordion'

export default {
  components: {
    VsAccordion,
    VsAccordionItem
  },

  setup() {
    return {
      faqList: [
        {
          q: 'Is it safe?',
          a: 'Yes. Soda uses the modern encrypted VLESS protocol. Connection security depends on the server you use and how the key is configured.'
        },
        {
          q: 'Is Soda a free app?',
          a: 'Soda is free to download. To use it, you need a VLESS key that you obtain separately.'
        },
        {
          q: 'Where can I get a key?',
          a: 'You can use your own server or get a VLESS key from any VPN provider that supports this protocol.'
        },
        {
          q: 'What is VLESS?',
          a: 'VLESS is a modern networking protocol designed for secure and flexible connections. It removes unnecessary components and delivers high performance.'
        },
        {
          q: 'Can I use my own server?',
          a: 'Yes. Soda fully supports the use of your own server without any restrictions.'
        }
      ]
    }
  }
}
</script>
